import { createContext } from 'react'
import { buildPayload } from 'utilities/apollo'

const CurrentUserContext = createContext(buildPayload())

export default CurrentUserContext
